import * as React from 'react';
const SvgCloseCircle = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 13, height: 13, fill: "none" }, props),
    React.createElement("circle", { cx: 6.5, cy: 6.5, r: 6.5, fill: "#D9D9D9" }),
    React.createElement("path", { stroke: "#fff", strokeWidth: 1.5, d: "M2.97 2.971 10.4 10.4M10.398 2.971 2.97 10.4" })));
export default SvgCloseCircle;
